import {
  // eslint-disable-next-line @exodus/import/no-deprecated
  DEFAULT_SERVER_URLS,
  // eslint-disable-next-line @exodus/import/no-deprecated
  ETHEREUM_LIKE_ASSETS,
  // eslint-disable-next-line @exodus/import/no-deprecated
  ETHEREUM_LIKE_MONITOR_TYPES,
} from '@exodus/ethereum-lib'
import assert from 'minimalistic-assert'

import { create } from './api.js'
import ApiCoinNodesServer from './api-coin-nodes.js'
import ClarityServer from './clarity.js'
import ClarityServerV2 from './clarity-v2.js'

export const ValidMonitorTypes = ['no-history', 'clarity', 'clarity-v2', 'magnifier']

export function createEvmServer({ assetName, serverUrl, monitorType }) {
  assert(assetName, 'assetName is required')
  assert(serverUrl, 'serverUrl is required')
  assert(monitorType, 'monitorType is required')
  switch (monitorType) {
    case 'no-history':
      return new ApiCoinNodesServer({ uri: serverUrl })
    case 'clarity':
      return new ClarityServer({ baseAssetName: assetName, uri: serverUrl })
    case 'clarity-v2':
      return new ClarityServerV2({ baseAssetName: assetName, uri: serverUrl })
    case 'magnifier':
      return create(serverUrl, assetName)
    default:
      throw new Error(`No server API found for ${assetName} and type ${monitorType}`)
  }
}

// @Deprecated
const serverMap = Object.fromEntries(
  // eslint-disable-next-line @exodus/import/no-deprecated
  ETHEREUM_LIKE_ASSETS.map((assetName) => {
    // eslint-disable-next-line @exodus/import/no-deprecated
    const monitorType = ETHEREUM_LIKE_MONITOR_TYPES[assetName]
    // eslint-disable-next-line @exodus/import/no-deprecated
    const serverUrl = DEFAULT_SERVER_URLS[assetName]
    return [assetName, createEvmServer({ assetName, serverUrl, monitorType })]
  })
)

export function getServer(asset) {
  const server = asset.baseAsset.server
  if (server) {
    return server
  }

  // legacy way using the global serverMap
  return getServerByName(asset.baseAsset.name)
}

export function getServerByName(baseAssetName) {
  console.warn(
    `Asking ${baseAssetName} server by name, please use asset.baseAsset.server or getServer(asset)`
  )
  const server = serverMap[baseAssetName]
  if (!server) throw new Error(`Unsupported base asset ${baseAssetName}`)
  return server
}
